import Slideshow from "../../classes/Slideshow";

export const initConstructionProgressContent = () => {
	const components = Array.from( document.querySelectorAll(`section.construction-progress-content`));
	
	if ( components.length )
	{
		components.forEach( ( component ) => {
			const slider = component.querySelector(`div.slideshow`);
			const videoContainer = component.querySelector( `div.youtube-frame[data-video-src]` );
			const videoChecker = document.querySelector( `input.tabs[value=video]` );
			
			if ( slider )
			{
				const bookmarksContainer = slider.querySelector(`ul.buttons`);
				const slidesContainer = slider.querySelector(`ul.slides`);
				const navsContainer = slider.querySelector(`ul.nav`);

				if ( bookmarksContainer || navsContainer)
				{
					new Slideshow({
						slidesContainer,
						bookmarksContainer,
						navsContainer,
						autoWidth: true,
					});
				}
			}
			
			if ( videoContainer && videoChecker )
			{
				const youtubeLink = videoContainer.dataset.videoSrc;
				const youtubeLinkRegex = /(.*)?v=/i;
				const youtubeLinkEmbedRegex = /(.*)?embed\//i;
				const youtubeScriptSrc = `https://www.youtube.com/iframe_api`;
				const youtubeScript = document.createElement( `script` );
				
				youtubeScript.src = youtubeScriptSrc;
				document.head.appendChild( youtubeScript );
				
				let youtubeId = '';
				if ( youtubeLinkRegex.test( youtubeLink ) )
				{
					youtubeId = youtubeLink.replace( youtubeLinkRegex, '')
				}
				else if ( youtubeLinkEmbedRegex.test( youtubeLink ) )
				{
					youtubeId = youtubeLink.replace( youtubeLinkEmbedRegex, '')
				}
				
				window.onYouTubeIframeAPIReady = () => {
					const adjustPlayer = () => {
						const playerCoords = player.getIframe().getBoundingClientRect();
							
						if ( playerCoords.width > 0 )
						{
							const newHeight = Math.round(playerCoords.width / (player.getIframe().width / player.getIframe().height));
							player.getIframe().style.height = `${newHeight}px`;
						}
					};
					
					const onPlayerReady = () => {
						player.getIframe().parentElement.classList.remove( 'fullback' );
						
						adjustPlayer();
					}
					
					const player = new YT.Player( videoContainer, {
						videoId: youtubeId,
						events: {
							'onReady': onPlayerReady,
						}
					});
					
					videoChecker.addEventListener( `input`, () => {
						if ( videoChecker.checked )
						{
							adjustPlayer();
						}
					});
					
					window.addEventListener( `resize` , () => {
						adjustPlayer();
					} );
				};
			}
		});
	}
}
